"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getAPI = _interopRequireDefault(require("./getAPI"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var demoObject = {
  index: {
    id: 'index',
    name: 'index',
    pageUrl: 'index'
  }
};

var getPropsAllPages = function getPropsAllPages() {
  return Object.values((0, _getAPI["default"])().pages || demoObject).filter(function (x) {
    return x.id !== 'root';
  }).map(function (_ref) {
    var name = _ref.name,
        id = _ref.id;
    return {
      title: name,
      value: id
    };
  });
};

var _default = getPropsAllPages;
exports["default"] = _default;